<template>
  <v-container fluid>
    <Navbar />
    <Filters
      name="GerenciadorArtigosFilters"
      :drawer="drawer"
      @input="drawer = $event"
      @filtraStatus="status = $event"
    />
    <Grid
      titulo="Artigos"
      :headers="gridHeaders"
      :items="articlesByStatus"
      @filtrar="drawer = true"
      @atualizaLista="atualizaLista"
      @editItem="editItem"
      @deleteItem="deleteItem"
      sortBy="classificacao"
      :filtroStatus="status"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { serialize } from '../../helpers';
import Grid from '../../components/shared/Grid';
import Filters from '../../components/shared/Filters';

export default {
  name: 'DocumentosGerenciadorView',
  components: {
    Grid,
    Filters
  },
  data: () => ({
    drawer: false,
    gridHeaders: [
      { text: 'Classificação', value: 'classificacao' },
      {
        text: 'Título',
        align: 'start',
        value: 'titulo',
      },
      { text: 'Emissão', value: 'createdAt' },
      { text: 'Autor', value: 'autor.nome' },
      { text: 'Tipo', value: 'tipo.descricao' },
      { text: 'Tags', value: 'tags' },
      { text: 'Status', value: 'status' },
      { text: 'Ações', value: 'actions', sortable: false },
    ],
    status: []
  }),
  computed: {
    ...mapGetters(['articles']),
    articlesByStatus() {
      if (this.status.length) return this.articles.filter(article => this.status.includes(article.status));
      return this.articles;
    }
  },
  methods: {
    ...mapActions([
      'fetchArticles',
      'deleteArticle',
    ]),
    atualizaLista() {
      this.fetchArticles({ acao: 'crud', status: 'Todos' });
    },
    editItem(payload) {
      this.$router.push({ name: 'Edita Documento', params: { id: payload._id } });
    },
    deleteItem(payload) {
      if (confirm(`Tem certeza que deseja excluir o documento: ${payload.titulo}?`)) {
        this.deleteArticle(payload._id);
      }
    }
  },
  created() {
    this.atualizaLista();
  },
  destroyed() {
    this.$store.dispatch('resetArticlesState');
  }
}
</script>

<style scoped>
.list-title {
  font-size: 1.125rem;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>